(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/rules/assets/javascripts/utils/keno-winplan.js') >= 0) return;  svs.modules.push('/components/numbergames/rules/assets/javascripts/utils/keno-winplan.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

let winplanData;
if (svs.isServer) {
  winplanData = require('./keno-winplan-data.es6');
} else {
  winplanData = svs.numbergames.rules.utils.keno_winplan.data;
}

const kenoTypes = {
  KENO_DEFAULT: 'keno',
  KENO_SYSTEM: 'kenoSystem'
};

function limitWin(win) {
  return Math.min(win, 40000000);
}

function recalculateLevelSize(_ref) {
  let {
    rowPrice,
    KW = 0,
    KKW = 0
  } = _ref;
  const multiplier = rowPrice / 5;
  return {
    KW: limitWin(KW * multiplier),
    KKW: limitWin(KKW * multiplier)
  };
}

const getKenoLevelWinPlanData = _ref2 => {
  let {
    type = kenoTypes.KENO_DEFAULT,
    level,
    rowPrice,
    systemNumbers
  } = _ref2;
  let maxSize = 11;
  let minSize = 0;
  const calculatedData = [];
  const levelDataType = winplanData[type];
  let levelData = levelDataType && levelDataType["size_".concat(level)];
  if (type === kenoTypes.KENO_SYSTEM) {
    maxSize = 10;
    minSize = 1;
    if (levelData) {
      levelData = levelData["m".concat(systemNumbers)];
    }
    if (!levelData) {
      levelData = new Array(maxSize);
    }
  }
  for (let i = maxSize; i >= minSize; i--) {
    const levelSizeData = levelData["corr_".concat(i)];
    const {
      KW = 0,
      KKW = 0,
      isDoubled
    } = levelSizeData || {};
    calculatedData.push(_objectSpread(_objectSpread({
      size: i
    }, isDoubled && {
      isDoubled: true
    }), recalculateLevelSize({
      rowPrice,
      KW,
      KKW
    })));
  }
  return calculatedData;
};

const getKenoLevelWinPlanTopWin = _ref3 => {
  let {
    type,
    level,
    rowPrice,
    systemNumbers,
    hasKungKeno
  } = _ref3;
  const levelObj = getKenoLevelWinPlanData({
    type,
    level,
    rowPrice,
    systemNumbers
  });
  const highestWinObj = levelObj.reduce((highest, compare) => highest.KW > compare.KW ? highest : compare);
  return hasKungKeno ? highestWinObj.KKW : highestWinObj.KW;
};

const getWinAmount = _ref4 => {
  var _corrObj$winKey;
  let {
    correctCount,
    level,
    hasKungKeno,
    rowPriceMulti = 1,
    type = kenoTypes.KENO_DEFAULT,
    systemNumbers
  } = _ref4;
  const winPlan = winplanData[type];
  if (!winPlan) return 0;
  let levelObj = winPlan["size_".concat(level)];
  if (!levelObj) return 0;
  if (type === kenoTypes.KENO_SYSTEM && systemNumbers) {
    levelObj = levelObj["m".concat(systemNumbers)];
  }
  const corrObj = levelObj["corr_".concat(correctCount)];
  if (!corrObj) return 0;
  const winKey = hasKungKeno ? 'KKW' : 'KW';
  const winAmount = (_corrObj$winKey = corrObj[winKey]) !== null && _corrObj$winKey !== void 0 ? _corrObj$winKey : 0;
  return limitWin(winAmount * rowPriceMulti);
};

const getMinimumCorrectByLevel = _ref5 => {
  var _winConditions$find;
  let {
    level,
    kungKeno = false
  } = _ref5;
  const {
    winConditions
  } = svs.numbergames.rules.KENO;
  return (_winConditions$find = winConditions.find(wc => wc.level === level && wc.kungKeno === kungKeno)) === null || _winConditions$find === void 0 ? void 0 : _winConditions$find.numbers;
};
if (svs.isServer) {
  module.exports = {
    kenoTypes,
    getKenoLevelWinPlanData,
    getKenoLevelWinPlanTopWin
  };
} else {
  svs.numbergames.rules.utils.keno_winplan.types = kenoTypes;
  svs.numbergames.rules.utils.keno_winplan.getLevelWinPlanData = getKenoLevelWinPlanData;
  svs.numbergames.rules.utils.keno_winplan.getLevelWinPlanTopWin = getKenoLevelWinPlanTopWin;
  svs.numbergames.rules.utils.keno_winplan.getWinAmount = getWinAmount;
  svs.numbergames.rules.utils.keno_winplan.getMinimumCorrectByLevel = getMinimumCorrectByLevel;
}

 })(window);